import React from 'react';
import './FloatingOrbs.css';

const FloatingOrbs: React.FC = () => (
  <div className="floating-orbs" aria-hidden="true">
    <span className="floating-orbs__orb floating-orbs__orb--1" />
    <span className="floating-orbs__orb floating-orbs__orb--2" />
    <span className="floating-orbs__orb floating-orbs__orb--3" />
  </div>
);

export default FloatingOrbs;
